import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\" id=\"icon-download\">\r\n<path d=\"M416,199.5h-91.4V64H187.4v135.5H96l160,158.1L416,199.5z M96,402.8V448h320v-45.2H96z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol